export function roundTo4(value: number): number {
  return Math.round(value * 10000) / 10000
}
